export default __webpack_public_path__ + "media/images/file_types/docx-150a9f8b3201f028d9acf8246210303d.svg";